export default __webpack_public_path__ + "static/media/000_Schiller_Der_kleine_Bork_Sample.32012cc7.mp3";